module.exports = __webpack_public_path__ + "static/media/resolving.4d495a96.svg";